import { FaStore, FaChartLine, FaBullhorn, FaUsers } from "react-icons/fa";
import { Section, ContentWrapper, TextSide, ImageSide, FeatureList, FeatureItem, FeatureIcon, ButtonsWrapper, ActionButton } from "./style";
import phone from "../../../../../components/images/venda-online.png";

const features = [
	{
		icon: FaStore,
		text: "Cadastro rápido da sua loja",
	},
	{
		icon: FaChartLine,
		text: "Painel completo de vendas e análises",
	},
	{
		icon: FaBullhorn,
		text: "Cupons e promoções para atrair clientes",
	},
	{
		icon: FaUsers,
		text: "Programa de fidelidade para seus clientes",
	},
];

export function ForShopkeepers({ onShopkeeperContact, onPartnershipContact }) {
	return (
		<Section>
			<div className="container">
				<ContentWrapper>
					<TextSide>
						<span className="label">Para lojistas</span>
						<h2>Leve sua loja para o próximo nível</h2>
						<p>
							Cadastre sua loja no iNove Clube e alcance milhares de clientes na sua
							região. Gerencie seus produtos, acompanhe suas vendas e cresça seu negócio.
						</p>
						<FeatureList>
							{features.map((feature) => {
								const Icon = feature.icon;
								return (
									<FeatureItem key={feature.text}>
										<FeatureIcon>
											<Icon size={18} />
										</FeatureIcon>
										<span>{feature.text}</span>
									</FeatureItem>
								);
							})}
						</FeatureList>
						<ButtonsWrapper>
							<ActionButton onClick={onShopkeeperContact}>
								Cadastrar minha loja
							</ActionButton>
							<ActionButton $variant="outline" onClick={onPartnershipContact}>
								Seja um parceiro
							</ActionButton>
						</ButtonsWrapper>
					</TextSide>
					<ImageSide>
						<img src={phone} alt="Cadastre sua loja" />
					</ImageSide>
				</ContentWrapper>
			</div>
		</Section>
	);
}
